<template>
  <select :value="selected" @input="onSelectOption">
    <option
      v-for="option in this.options"
      :key="option[identifier]"
      :value="option[identifier]"
      :disabled="option.disabled"
    >{{option[label]}}</option>
  </select>
</template>
<script>
export default {
  props: ["options", "selected", "onSelect", "label", "identifier"],
  methods: {
    onSelectOption(event) {
      return this.onSelect(event.target.value);
    }
  }
};
</script>